import { PaymentLedger } from "../../../components/payments/PaymentLedger";

export function PaymentHistoryPage() {
  return <PaymentLedger />;
}
